import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'inputDate',
    standalone: false
})
export class InputDatePipe implements PipeTransform {
  transform(value: Date): any {
    if (!value) {
      return '';
    }
    return moment(value).format('YYYY-MM-DD');
  }
}
